// CACHE THE DOM
const $introbuttons = $('.intro-buttons');
const $guestLoginButton = $('#btn-login-guest');
const $registerButton = $('.btn-switch-to-register');
const $loginButton = $('.btn-switch-to-login');
const $adminLoginButton = $('#btn-admin-login');

const $logoleft = $('.logo-left');
const $logomiddle = $('.logo-middle');

const $login = $('#login');
const $loginForm = $('#login-form');
const $usernameField = $('#username');
const $passwordField = $('#password');
const $passwordResetButton = $('.btn-password-reset');
const $pwdCheck1 = $('#password-check1');
const $pwdCheck2 = $('#password-check2');
const $forgotPassword = $('#forgotPassword');

const $forgotPwdUsernameField = $('#usernameForgot');
const $forgotPwdEmailField = $('#emailForgot');
const $sendPasswordResetButton = $('.send-password-reset');

const $signUpForm = $('#signUp');
const $newUsernameInput = $('#newUsr');
const $avatarSelector = $('#avatarSelector');
const $regionInput = $('#region');
const $typeOfUserDropdown = $('#type');
const $newUserEmailInput = $('#newEmail');
const $newUserPwdInput = $('#newPwd');
const $newSchoolInput = $('#newSchool');

const $formFeedback = $('.form-feedback');

// NOTIFICATIONS
function formFeedback(notification) {
  $formFeedback.html(notification);
  $formFeedback.show();
  setTimeout(() => {
    $formFeedback.html('');
    $formFeedback.hide();
  }, 4000);
}

// LOGIN
function login(user) {
  $.post('/login', user, (data) => {
    if (data === 'Username not found.') {
      $usernameField.addClass('form-control-invalid');
      $passwordField.removeClass('form-control-invalid');
      formFeedback("Sorry, we couldn't find that user");
    } else if (data === 'Invalid password.') {
      $passwordField.addClass('form-control-invalid');
      $usernameField.removeClass('form-control-invalid');
      formFeedback('Sorry, that password is incorrect');
    } else if (data === 'Login success') {
      $usernameField.removeClass('form-control-invalid');
      $passwordField.removeClass('form-control-invalid');
      $formFeedback.html('Login success');
      window.location.href = '/dashboard';
    }
  });
}

$loginForm.submit((event) => {
  event.preventDefault();
  const user = { username: $usernameField.val().toLowerCase(), password: $passwordField.val() };
  login(user);
});

function loginAdmin(user) {
  $.post('/loginAdmin', user, (data) => {
    if (data === 'Invalid email or password.') {
      formFeedback("Sorry, login didn't work");
    } else if (data === 'Login success') {
      $formFeedback.html('Login success');
      window.location.href = '/admin';
    }
  });
}

$adminLoginButton.click(() => {
  const user = { username: $('#username').val(), password: $('#pwd').val() };
  loginAdmin(user);
});

$guestLoginButton.click(() => {
  const user = { guest: true };
  $.post('/register', user, (data, textStatus, jqXHR) => {
    if (data.code === 400) {
      formFeedback(data.data);
    } else if (data.guest) {
      const guest = { username: data.username, password: 'eddie123' };
      login(guest);
    } else {
      formFeedback('Username taken, please select another username');
    }
  });
});

// REGISTRATION
$signUpForm.submit((e) => {
  e.preventDefault(); // otherwise page reloads
  const usernameVal = $newUsernameInput.val();
  const username = usernameVal.toLowerCase();
  console.log("new username is " + username);
  if (username.length > 10) {
    formFeedback('Username must be 10 characters or less');
    return;
  }
  const avatarString = $avatarSelector.children('.active').children('img').attr('src');
  const newUser = {
    username,
    region: $regionInput.val(),
    type: $typeOfUserDropdown.val(),
    email: $newUserEmailInput.val(),
    password: $newUserPwdInput.val(),
    guest: false,
    avatar: avatarString,
    school: $newSchoolInput.val(),
  };

  $.post('/register', newUser, (data, textStatus, jqXHR) => {
    if (data.code === 400) { // 400 means bad request error
      $formFeedback.html(data.data);
    } else if (data === 'Login success') {
      $formFeedback.html('Login success');
      const user = newUser;
      login(user);
    } else {
      console.log("This is the data");
      console.log(data);
      formFeedback(data);
    }
  });
});

// BUTTONS
$registerButton.click(() => {
  $introbuttons.hide();
  $login.hide();
  $logomiddle.hide();
  $logoleft.show();
  $signUpForm.show();
});

$loginButton.click(() => {
  $introbuttons.hide();
  $login.show();
  $signUpForm.hide();
});

function closeLogin() {
  $login.hide();
  $introbuttons.show();
}

function closeRegistration() {
  $signUpForm.hide();
  $logoleft.hide();
  $logomiddle.show();
  $introbuttons.show();
}
function showForgotPassword() {
  $login.hide();
  $forgotPassword.show();
}
function closeForgotPassword() {
  $forgotPassword.hide();
  $formFeedback.hide();
  $logoleft.hide();
  $logomiddle.show();
  $introbuttons.show();
}

// FORGOT PASSWORD
$sendPasswordResetButton.click((e) => {
  e.preventDefault();
  const user = {
    username: $forgotPwdUsernameField.val(),
    email: $forgotPwdEmailField.val(),
  };
  $.post('/forgot', user, (data) => {
    if (data === 'Invalid email or username.') {
      formFeedback("Sorry, that email or username doesn't work");
    } else {
      formFeedback('Password email sent, please check your email');
    }
  });
});

function closePwdReset() {
  window.location.href = '/?reset-password=false';
}

// NEEDS POLYFILL FOR NEW URL ON SAFARI MOBILE EG BABEL

// UPDATE PASSWORD #tidy could be a separate JS file
$passwordResetButton.click((e) => {
  e.preventDefault();
  const password1 = $pwdCheck1.val();
  const password2 = $pwdCheck2.val();
  if (password1 === password2) {
    const url = new URL(window.location.href);
    const username = url.searchParams.get('username');
    const token = url.searchParams.get('token');
    const passwordObj = {
      password: password1,
      token,
      username,
    };
    $.post('/password-new', passwordObj, (data, textStatus, jqXHR) => {
      if (data === 'password reset failed') {
        formFeedback(data);
      } else {
        window.location.href = '/?reset-password=true';
      }
    });
  } else {
    formFeedback('passwords must match');
  }
});

// PASSWORD RESET MSG ON PAGE LOAD TO CHECK IF IT INCLUDES RESET PASSWORD
const passwordUrl = new URL(window.location.href);
if (passwordUrl.searchParams.get('reset-password') === 'true') {
  formFeedback('Your password has been reset');
}

// CACHE IMAGES
const urlImage = [
  'img/level-1.png',
  'img/level-2.png',
  'img/level-3.png',
  'img/avatar-1.png',
  'img/avatar-2.png',
  'img/avatar-3.png',
  'img/avatar-4.png',
  'img/avatar-5.png',
  'img/crunchTimeLogo.png',
  'img/xp.png',
  'img/points.png',
  'img/host-happy.png',
  'img/genesisLogo.png',
];

urlImage.forEach((imageUrl) => {
  const img = new Image();
  img.src = imageUrl;
});
